export default __webpack_public_path__ + "static/media/Standard48.714abd17.png";